document.addEventListener('DOMContentLoaded', function() {
  const dynamicNameElement = document.querySelector('[data-dynamic-name]');
  const dynamicName = dynamicNameElement.textContent;
  const optionValues = document.querySelectorAll('.variant-picker__option-values [data-hover-label]');

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const updateDynamicName = debounce(function(text) {
    if (dynamicNameElement) {
      dynamicNameElement.textContent = text;
    }
  }, 50);

  optionValues.forEach(function(optionValue) {
    optionValue.addEventListener('mouseenter', function() {
      updateDynamicName(this.getAttribute('data-hover-label'));
    });

    optionValue.addEventListener('mouseleave', function() {
      updateDynamicName(dynamicName);
    });
  });
});